String.prototype.truncate = function (length) {
    const s = this;
    return s.length > length
        ? `${s.substring(0, length)}…`
        : s
}